import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import UnlockAccountForm from "./UnlockAccountForm";
import UnlockNewPassword from "../NewPassword/UnlockNewPassword";
import UnlockOtp from "../OTP/UnlockOtp";

const UnlockAccount = () => {
    const navigate = useNavigate()
    const [currentState, setCurrentState] = useState("");
    const [email, setEmail] = useState("");
    const [OTP, setOTP] = useState("");

    const onNextClick = (nextState) => {
        setCurrentState(nextState);
    };
    
    const currentComponent = () => {
        switch (currentState) {
            case "verifyOTP":
                return (

                    <UnlockOtp
                        OTP={OTP}
                        email={email}
                        onNextClick={() => onNextClick("changePassword")}
                        onCancelClick={() => onNextClick("")}
                        setOTP={setOTP}
                        setEmail={setEmail}
                    />
                );
            case "changePassword":
                return (
                    <UnlockNewPassword
                        email={email}
                        OTP={OTP}
                        onNextClick={() => onNextClick(navigate("/"))}
                        onCancelClick={() => onNextClick("")}
                        setEmail={setEmail}
                        setOTP={setOTP}
                    />
                );

            default:
                return <UnlockAccountForm
                    email={email}
                    setEmail={setEmail}
                    setOTP={setOTP}
                    onNextClick={() => onNextClick("verifyOTP")}
                    onCancelClick={() => onNextClick(navigate("/"))}
                />
        }
    }

    return (
        <>
            {currentComponent()}
        </>
    )

}

export default UnlockAccount;
